import { Fragment, type ReactNode } from 'react';

import { splitMarkers } from './markers.ts';
import { t, type Key, type Message, type ParamRecord, type ParamsOf } from './t.ts';

type Props<K extends Key> = {
  k: K;
  /** One renderer per marker the English uses: `link` for `<link>…</link>`. */
  parts: Record<string, (text: string) => ReactNode>;
} & ([ParamsOf<K>] extends [never] ? { params?: undefined } : { params: ParamRecord<K> });

/**
 * A catalog string with markup in it (spec §4.1). The translation decides
 * where the link falls in the sentence, which a string concatenated around a
 * JSX element cannot let it do.
 */
export function T<K extends Key>({ k, params, parts }: Props<K>) {
  const text = t({ key: k, params } as Message);
  return (
    <>
      {splitMarkers(text).map((part, i) => {
        const render = part.tag === null ? undefined : parts[part.tag];
        return <Fragment key={i}>{render ? render(part.text) : part.text}</Fragment>;
      })}
    </>
  );
}
